import { render, staticRenderFns } from "./RulesByGroup.vue?vue&type=template&id=60e00aba&scoped=true&"
import script from "./RulesByGroup.vue?vue&type=script&lang=js&"
export * from "./RulesByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e00aba",
  null
  
)

export default component.exports